'use strict';

import Vue from 'vue/dist/vue.common.js';
import EventBus from './event-bus';

// components
import Modal from '../components/modal';
import PersonUserSubmissionForm from '../components/person-user-submission-form';
import DistrictUserSubmissionForm from '../components/district-user-submission-form';

// vuex
import store from '../vuex/store';

let UserSubmission = Vue.extend({
  store,
  components: {
    Modal,
    PersonUserSubmissionForm,
    DistrictUserSubmissionForm
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn;
    }
  },
  data() {
    return {
      authoring: false
    };
  },
  mounted() {
    const self = this;
    EventBus.$on('closeModal', () => {
      self.authoring = false;
    });
  }
});

export default UserSubmission;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/user-submission.js